module.exports = __webpack_public_path__ + "static/media/image-not-found.d58bbd74.jpg";